// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { cartLinkStyles } from "@turnerBlueprint/Overrides/Widgets/Common/CartLink";
import { fontConfig } from "@turnerBlueprint/XDL/PreStyle/typography";
import { color, xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

cartLinkStyles.routerLink = {
    typographyProps: {
        variant: "headerSecondary",
    },
    icon: {
        iconProps: {
            size: 24,
        },
    },
    color: "text",
    css: css`
        height: 21px;
        padding: 0 4px 0 10px;
    `,
};

cartLinkStyles.countBadge = {
    size: 12,
    weight: fontConfig.weight.medium,
    color: "common.ui1",
    css: css`
        background-color: ${color("common.ui6")};
        border: 1px solid ${color("common.ui1")};
        text-align: center;
        border-radius: 25px;
        line-height: 24px;
        height: 25px;
        min-width: 25px;
        position: absolute;
        bottom: 7px;
        left: 14px;
        padding: 0 2px;

        & + ${IconWrapper} {
            margin-right: 15px;
        }

        ${xScreen("lte", "md")} {
            position: relative;
            left: auto;
            bottom: auto;

            &.cart-empty {
                display: none;

                & + .menu-icon {
                    display: block;
                }
            }

            & + ${IconWrapper} {
                margin-right: 0;
            }
        }
    `,
};

cartLinkStyles.headerClickable = {
    icon: {
        css: css`
            ${xScreen("lte", "md")} {
                display: none;
            }
        `,
    },
};
